import React, { useState } from 'react'
import './addcard.sass'

import { PlainInput } from '../../components/common/Input'
import Header from '../../components/common/Header'

export default function AddCard() {

    const [addConf, setAddConf] = useState(false)

    const toggleTNC = () => {
        setAddConf(!addConf)
    }
    return (
        <div id="addCardPage">
            <Header img="cc.svg" text="Card Details" />

            <div className="cc-input-wrapper">
                <p>
                    Email
                </p>
                <PlainInput />
            </div>

            <div className="cc-input-wrapper">
                <p>
                    Name on the card
                </p>
                <PlainInput />
            </div>

            <div className="cc-input-wrapper">
                <p>
                    Card Number
                </p>
                <PlainInput />
            </div>

            <div className="cc-input-row">
                <div className="cc-input-col">
                    <div className="cc-input-wrapper">
                        <p>
                            Exp (MM)
                </p>
                        <PlainInput />
                    </div>
                </div>

                <div className="cc-input-col">
                    <div className="cc-input-wrapper">
                        <p>
                            Exp (YYYY)
                        </p>
                        <PlainInput />
                    </div>
                </div>

                <div className="cc-input-col">
                    <div className="cc-input-wrapper">
                        <p>
                            CVC
                </p>
                        <PlainInput />
                    </div>
                </div>
            </div>

            <div className='addCardConf'>
                {addConf ? <img src={require('../../assets/icons/checkbox_a.svg')} onClick={toggleTNC} alt="checked" /> : <img src={require('../../assets/icons/checkbox.svg')} onClick={toggleTNC} alt="unchecked" />}
                <p id="walletNormalText" style={{ marginLeft: '10px' }}>I confirm that you are at least 18 years old and the age of majority in your place of residence.</p>
            </div>

            <p id="addcardterms">Lovr Online will make a one-time charge of $0.10 when adding your payment card. The charges on your credit card statement will appear as "Lovr Online".</p>

            <div className="addCCRow">
            <div className="addCC">
            <p>SUBMIT NEW CARD</p>
            </div>
            </div>
        
        </div>
    )
}
